<template>
  <div class="mod-card passenger-card">
    <div class="cell-header">
      <h3>
        卡券
        <a-checkbox @change="onCheck" :checked="show">使用卡券
          <router-link class="links" v-for="item in cardAgreement" :to="item.url" :key="item.url" target="_blank">{{ item.name }}</router-link>
        </a-checkbox>
        <!-- TODO: 配置cms -->
        <span class="card-warn" v-show="valid.msg"><a-icon type="info-circle" /> {{ valid.msg }} </span>
      </h3>
    </div>
    <div class="cell-body" v-if="show">
      <a-spin :spinning="loading">
        <div v-if="!loading && !cardCoupon.coupons?.length" class="empty">
          暂时没有可使用的卡券。
        </div>
        <card-group
          v-else
          :options="cardCoupon.coupons"
          @change="onChange"
        >
        </card-group>
      </a-spin>
    </div>
  </div>
</template>

<script>
import CardGroup from '@/components/coupon/card-group'

export default {
  data () {
    return {
      show: false,
      selectedCoupon: {}
    }
  },
  props: {
    cardCoupon: Object,
    valid: Object,
    loading: Boolean,
    cardAgreement: Array
  },
  watch: {
    valid (value) {
      if (!value.valid) {
        this.show = false
      }
    }
  },
  methods: {
    onCheck () {
      this.show = !this.show

      if (!this.show) {
        this.selectedCoupon = {}
        this.$emit('change', this.selectedCoupons)
      }

      this.$emit('visible', this.show)
    },
    onChange (value) {
      this.selectedCoupons = value
      this.$emit('change', this.selectedCoupons)
    }
  },
  components: {
    CardGroup
  }
}
</script>

<style lang="less">
  .mod-card.passenger-card {

    .cell-header {
      line-height: 30px;
      font-size: 24px;

      .ant-checkbox-wrapper {
        margin-left: 26px;
      }
    }

    .card-warn {
      color: @primary-color;
      font-size: 14px;
    }

    .cell-body {
      .action {
        display: inline-block;
        padding-top: 16px;
        vertical-align: top;
      }

      .empty {
        text-align: center;
        color: #888;
        font-size: 14px;
        margin-top: 15px;
      }
    }

    .tip {
      margin-top: 20px;
    }

    .card-content {
      overflow: hidden;
    }
  }
</style>
